var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "editor-header" },
    [
      _c("h3", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "el-button",
        {
          attrs: { type: "text", size: "small" },
          on: { click: _vm.handleClose },
        },
        [_c("i", { staticClass: "el-icon-close" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }